import { Modal, AutoComplete, Select } from 'antd'
import { addSpanToWhitespace } from 'admin/lib/Functions/whiteSpaceHelper'
import { massUpdatableFields } from 'admin/lib/GroupUpdateHelpers/massUpdateableFields'

export function UpdateRecordsModal({
  visible,
  onOk,
  onCancel,
  submitEnabled,
  updateRecords,
  tableProps,
  updateRecordsValue,
  handleUpdateRecordsSelectionChange,
  selectedValues
}) {
  const NULL_REPLACEMENT = '-blank-'

  return (
    <Modal
      open={visible}
      title="Update records"
      bodyStyle={{ minHeight: '168px' }}
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{
        disabled: !submitEnabled,
        style: {
          minWidth: '130px'
        }
      }}
      cancelButtonProps={{ type: 'secondary' }}
      okText={'Update records'}
    >
      <div>
        <p style={{ marginBottom: '3px' }}>
          Set {massUpdatableFields[tableProps.moduleName][tableProps.fieldName]}{' '}
          to:
        </p>
        <AutoComplete
          style={{ width: '100%' }}
          onChange={handleUpdateRecordsSelectionChange}
          value={updateRecordsValue}
        >
          {selectedValues.map(valueCount => {
            return (
              <Select.Option value={valueCount.value}>
                {addSpanToWhitespace(valueCount.value) ?? NULL_REPLACEMENT}{' '}
                {valueCount.count ? `(${valueCount.count})` : ''}
              </Select.Option>
            )
          })}
        </AutoComplete>
      </div>
      {updateRecords.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <p className="warning">
            <b>Warning!</b> Your selection will update{' '}
            {updateRecords.reduce(
              (partialSum, a) => partialSum + a.recordAndProjectIds.length,
              0
            )}{' '}
            records.
          </p>
        </div>
      )}
    </Modal>
  )
}
